import { useCallback, useState } from 'react';

const DEFAULT_DURATION_MS = 7000;

/**
 * Top-right stacked toasts (PageToastStack). severity: success | error | warning | info
 */
export function usePageToast(autoHideMs = DEFAULT_DURATION_MS) {
  const [pageToasts, setPageToasts] = useState([]);

  const dismissPageToast = useCallback((id) => {
    setPageToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const pushPageToast = useCallback((message, severity = 'success') => {
    if (message == null || message === '') return;
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    const createdAt = Date.now();
    setPageToasts((prev) => [...prev, { id, message: String(message), severity, createdAt }]);
    if (autoHideMs > 0) {
      window.setTimeout(() => {
        setPageToasts((prev) => prev.filter((t) => t.id !== id));
      }, autoHideMs);
    }
  }, [autoHideMs]);

  const showSuccess = useCallback((message) => pushPageToast(message, 'success'), [pushPageToast]);
  const showError = useCallback((message) => pushPageToast(message, 'error'), [pushPageToast]);
  const showWarning = useCallback((message) => pushPageToast(message, 'warning'), [pushPageToast]);
  const showInfo = useCallback((message) => pushPageToast(message, 'info'), [pushPageToast]);

  return {
    pageToasts,
    pushPageToast,
    dismissPageToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
}

export default usePageToast;
